const DomesticInternationalTours = () => {
    return (
        <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

                <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[30rem]">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Domestic / International Tours
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        With the full range of value-added services such as visa facilitation, consultancy, air-ticketing, 
                        hotel booking, concierge and travel insurance, the signature TCS standards of visa processing, 
                        assistance at arrival, hotel accommodation and transportation have been commended by our 
                        local and international partners. Whether it is business, leisure, group tours, cruises 
                        to exotic destinations, or religious pilgrimages, TCS goes the extra mile in facilitating its customers.
                    </p>
                  
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/Intiana/image-4.jpg" alt="" className="rounded-md max-w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>
    )
}
export default DomesticInternationalTours;